
export const colorEstadosChip = {
    'Pendiente': { isYellow: true },
    'Correccion': { isYellow: true },
    'Demorado': { isYellow: true },
    'Aprobado': { isGreen: true },
    'Rechazado': { isRed: true }
};

export const colorEstadosCIChip = {
    'Pendiente': { isYellow: true },
    'Correccion': { isYellow: true },
    'Aprobado': { isGreen: true },
    'Rechazado': { isRed: true }
};